module.exports = __webpack_public_path__ + "static/media/V_pictos-05.5222364e.svg";